// Internet Explorer 11 requires polyfills and partially supported by this project.
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import './i18n';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { reloadOnce } from '@fuse/utils/chunkReload';

/**
 * PGSS-5456: recover from a route chunk that no longer exists.
 *
 * Vite fires `vite:preloadError` when it cannot fetch a dynamically imported module -- typically a
 * tab opened before a deploy still asking for the previous content hash. Left alone the rejection
 * propagates into React and blanks the screen, and the user has to work out that refreshing fixes
 * it. Reloading here does that for them; reloadOnce refuses to loop.
 */
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnce()) {
    // Stop Vite rethrowing while the tab is already navigating away.
    event.preventDefault();
  }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
